import { TwcProduct } from '../../../twc-products';

export const SEA_SURFACE_TEMPERATURE_PRODUCT_DATA: TwcProduct = {
  id: 'sea-surface-temperature',
  defaultProductId: 'seaSurfaceTemperature-boeing',
  productName: 'Weather-Sea-Surface-Temp-Forecast-TWC',
  label: 'Sea Surface Temperature',
  weatherType: 'SEA_SURFACE_TEMPS',
  description:
    'TWC product (raster, forecast) - Global Sea Surface Temperature Analysis',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 60,
  lodMax: 4,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 180,
  flightLevelProductIds: {},
  zOrder: 85
};
